import 'css-chunksrc/client/scenes/workloads/wbs/tags/form/styles.scss';export default {
  "form": "_form_1ukwv_1",
  "main": "_main_1ukwv_8",
  "input": "_input_1ukwv_18",
  "button": "_button_1ukwv_32",
  "list": "_list_1ukwv_45",
  "item": "_item_1ukwv_51"
};